import { LangProvider } from './context/LangContext';
import HeroSection from './components/Hero/HeroSection';
import Navbar from './components/Navbar/Navbar';
import AboutSection from './components/About/AboutSection';
import SkillsSection from './components/Skills/SkillsSection';
import CustomCursor from './components/utils/CustomCursor';
import ProjectsSection from './components/Projects/ProjectsSection';
import ExperienceSection from './components/Experience/ExperienceSection';
import ContactSection from './components/Contact/ContactSection';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <LangProvider>
      <div>
        <CustomCursor />
        <Navbar />
        <HeroSection />
        <AboutSection />
        <SkillsSection />
        <ProjectsSection />
        <ExperienceSection />
        <ContactSection />
        <Footer />
      </div>
    </LangProvider>
  );
}

export default App;